import { ref, watch } from 'vue'

const STORAGE_KEY = 'discussions_selected_org'

function tryLoad() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

function trySave(org) {
  try {
    if (org) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ id: org.id, name: org.name }))
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    // storage unavailable — ignore
  }
}

// Module-level singleton — one ref shared across all callers.
// Every component that calls usePersistedOrg() gets the same ref instance,
// so a change in any component is immediately visible everywhere.
const selectedOrg = ref(tryLoad())

watch(selectedOrg, (org) => trySave(org))

export function usePersistedOrg() {
  return { selectedOrg }
}
